<script>
  import { onMount } from "svelte";
  import { payments } from "../../models/payments.js";
  import { stripe } from "../../services/stripe.js";
  import Alert from "../../components/Alert.svelte";

  let paymentMethods = null;
  let card = null;
  let newCard = true;
  let error = null;
  let loading = false;

  onMount(async () => {
    await payments.loadMethods();

    card = await stripe.getStripeElement();
    card.mount("#card-element");

    card.on("change", function(event) {
      var displayError = document.getElementById("card-errors");
      if (event.error) {
        error = event.error.message;
      } else {
        error = null;
      }
    });
  });

  async function deletePayment(id) {
    error = null;
    await payments.deleteMethod(id);
  }

  async function addPayment() {
    let si = await payments.getSetupIntent();
    await stripe.confirmSetupIntent(si.client_secret, card);
    loading = true;
    setTimeout(loadPaymentMethods, 5000);
    card.clear();
  }

  async function loadPaymentMethods() {
    await payments.loadMethods();
    if ($payments.methods.length === 0){
      error = "Failed to attach payment method. Please refresh and try again."
    }
    loading = false;
  }
</script>

<style type="text/less">
  hr {
    width: 100%;
  }

  .payment-method {
    border-top: solid 1px var(--col-gray-80);

    &:last-child {
      border-bottom: solid 1px var(--col-gray-80);
    }
  }

  .payment-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--spacing-sm) 0;
    height: calc(var(--line-height) * 2);
  }

  .card-form-row {
    padding: var(--spacing-sm) 0;
    height: calc(var(--line-height) * 2);
    display: flex;
    flex-wrap: wrap;
  }

  .card-only {
    flex: 1;
    align-self: center;
  }

  .card-form #card-element {
    padding: 10px;
    border: 1px solid #f7f7f7;
    background-color: #f7f7f7;
    border-radius: 30px;
    width: 95%;
    margin: 0 auto;
  }

  .card-form input {
    -webkit-animation: 1ms void-animation-out;
  }

  .card-form input::-webkit-input-placeholder {
    color: #4c4c4c;
  }

  .card-form input::-moz-placeholder {
    color: #4c4c4c;
  }

  .card-form input:-ms-input-placeholder {
    color: #4c4c4c;
  }

  .card-form button {
    align-self: flex-end;
  }
</style>

<h2>Your Payment Methods</h2>
{#if loading}
Loading...
{:else}
{#if $payments.methods !== null}
  {#each $payments.methods as p}
    <div class="payment-method">
      <div class="payment-details">
        <div>Last Four Digits: {p.last_four_digits}</div>
        <div>Expiration Date: {p.exp_month} / {p.exp_year}</div>
        <div>Billing Zip: {p.billing_zip}</div>
        <button class="btn btn-danger" on:click={deletePayment(p.id)}>
          Delete
        </button>
      </div>
    </div>
  {/each}
{/if}

<div class="card-form payment-method">
  <form>
    <div class="card-form-row">
      <div class="card-only">
        <div id="card-element" />
      </div>
      <button
        class="btn"
        disabled={error !== null}
        on:click|preventDefault={() => addPayment()}>
          {#if $payments.methods === null || $payments.methods.length === 0}
                  Add
          {:else}
                  Update
          {/if}
      </button>
    </div>
  </form>
</div>
{/if}

{#if error !== null || $payments.error}
  <Alert type="danger" icon="warning">
    {error || $payments.error}
  </Alert>
{/if}

